module.exports = __webpack_public_path__ + "static/aftershock_report-61199d4b5df66cc8464525da79091a89.pdf";